export default __webpack_public_path__ + "static/media/Capture1.e6b1bc9e.PNG";